import { RMMaterialStrategy } from "../../builders/strategies/rmMaterialStrategy"

export class FMMaterialStrategy extends RMMaterialStrategy {}
